import { PARENT_REF_TYPE_NAME } from '@ardoq/api-types';
import type { TripleWithContext } from './toTriplesWithContext';

export const isCreatableTriple = (triple: TripleWithContext): boolean =>
  triple.referenceType !== PARENT_REF_TYPE_NAME &&
  triple.sourceInstancesWithWritePermissions.length > 0 &&
  triple.targetInstances.length > 0;
